import classnames from 'classnames'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { groupBy, isEmpty } from 'lodash'
import moment from 'moment-timezone'

import ScheduleSessionCard from './ScheduleSessionCard'

import classes from './SessionsList.module.scss'
import { ReactComponent as CalendarIcon } from '../../assets/images/common/icons/circle-calendar.svg'

const SessionsList = ({
  schedule,
  timezone,
  isEditable,
  showPastSessions,
  className,
}) => {
  const { t } = useTranslation()

  const groupedSessions = useMemo(() => {
    const sessions = showPastSessions
      ? schedule?.scheduleSessions
      : schedule?.scheduleSessions.filter(
        (s) => moment(s.startDate) >= moment(new Date())
      )

    return groupBy(sessions, (session) =>
      moment.tz(session.startDate, timezone).format('YYYY-MM-DD')
    )
  }, [showPastSessions, schedule, timezone])

  return (
    <div className={className}>
      {!schedule || isEmpty(groupedSessions) ? (
        <div className='d-flex flex-column align-items-center'>
          <CalendarIcon className={classes.calendarCardIcon} />
          <h4 className={classnames('mt-2', classes.title)}>{t('schedules.list.noSessionsScheduled')}</h4>
          <p className={classes.content}>
            {t('schedules.list.emptyStateLine1')}
            <br />
            {t('schedules.list.emptyStateLine2')}
          </p>
        </div>
      ) : (
        Object.entries(groupedSessions)
          .map(([date, sessions]) => (
            <ScheduleSessionCard
              key={date}
              sessions={sessions}
              isEditable={isEditable}
              timezone={timezone}
            />
          ))
      )}
    </div>
  )
}

SessionsList.propTypes = {
  schedule: PropTypes.object,
  className: PropTypes.string,
  timezone: PropTypes.string.isRequired,
  showPastSessions: PropTypes.bool,
  isEditable: PropTypes.bool,
}

export default SessionsList
